function GetApiUrl() {
  if (window.apiurl) {
    return window.apiurl;
  }
}
export default GetApiUrl;